module.exports = __webpack_public_path__ + "static/media/twitterWhite.b08d6724.svg";